import { ICardEdit } from '../../services/operaciones/model/ICardEdit';

export enum Secciones {
  /** datos de la coti + filtros usados + datos de naty ¿usar subtítulos? */
  Cotizacion = 'Cotizacion',
  /** gestión de la cotización (fecha de proxima visita, ¿chat?) */
  Seguimiento = 'Seguimiento',
  /** medios de contacto con el pasajero ¿mezclar con Gestión? */
  Contacto = 'Contacto',
  /** datos de los pasajeros viajantes */
  Pasajeros = 'Pasajeros',

  /** datos generales de la Operación (nro + ¿totales generales?) */
  Operacion = 'Operacion',
  /** datos del producto + proveedor + upgrades + etc */
  Producto = 'Producto',
  /** datos del Pago */
  Pago = 'Pago',
  /** datos de los vouchers (vouchers + errores en generación o envío) */
  Vouchers = 'Vouchers',
  /** datos de facturación */
  Facturacion = 'Facturacion',
  /** datos de las comisiones de la venta (comision para clientes y para Vendedores) */
  Comisiones = 'Comisiones',
  /** datos de las Conciliacion */
  Conciliacion = 'Conciliacion',
  /** Devolucion del pago */
  Devoluciones = 'Devoluciones',
}

export type ICardSeccion = {
  /** código de la Sección */
  id: Secciones;

  /** indica si se debe mostrar la sección en el menú */
  hide: (data: ICardEdit) => boolean
}

export const AllSecciones : ICardSeccion[] = [
  { id: Secciones.Operacion, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Cotizacion, hide: (data: ICardEdit) => false },
  { id: Secciones.Producto, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Pasajeros, hide: (data: ICardEdit) => !data?.operacion },  
  { id: Secciones.Contacto, hide: (data: ICardEdit) => false },
  { id: Secciones.Pago, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Vouchers, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Facturacion, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Comisiones, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Conciliacion, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Devoluciones, hide: (data: ICardEdit) => !data?.operacion },
  { id: Secciones.Seguimiento, hide: (data: ICardEdit) => false },
]